import {SxProps, Theme} from "@mui/material";
import {CSSProperties} from "react";

export const ScoreOuterBoxStyle: CSSProperties = {
	width: "100%", height: "100%",
	display: "flex", flexDirection: "column",
	justifyContent: "center", alignItems: "center"
}
